import { render, staticRenderFns } from "./MagazineArticle.vue?vue&type=template&id=41b5d124&"
import script from "./MagazineArticle.vue?vue&type=script&lang=js&"
export * from "./MagazineArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports